var exports = {
  "M": "CopyLinkSection.module__linkFooter___Z0laen",
  "e": "CopyLinkSection.module__linkSectionLabel___Z0laen",
};

module.exports = exports;
